/* Ayudate · Sesión del panel de administración
   Mismo principio que sesionTutor.js: el token vive en localStorage para
   sobrevivir un F5, y el servidor es la única fuente de verdad sobre si
   sigue siendo válido (ver CacheService en iniciarSesionAdmin/
   validarSesionAdmin, apps-script.gs) — acá solo se guarda dónde vive del
   lado del navegador. La sesión de admin dura como mucho 6 horas (el
   límite de CacheService), bastante menos que las 24 h del dashboard de
   tutor: si venció, el panel simplemente vuelve a pedir la contraseña. */

const CLAVE = "ayudate_sesion_admin";

export function guardarSesionAdmin(token) {
  localStorage.setItem(CLAVE, token);
}

export function leerSesionAdmin() {
  try {
    return localStorage.getItem(CLAVE) || null;
  } catch {
    return null;
  }
}

export function borrarSesionAdmin() {
  localStorage.removeItem(CLAVE);
}
